<app-loading *ngIf="contentReady"></app-loading>
<div class="addresses-container bg-light" [class.margin-btm]="!isCreateOrder"
    [class.addresses-container]="!isCreateOrder" [class.margin-btm-10]="isCreateOrder">

    <div class="address-card">
        <form [formGroup]="addressForm" (ngSubmit)="addAddress()" [class.mb-4]="!isCreateOrder">
            <div class="row">
                <!-- اسم العنوان -->
                @if(!isCreateOrder){
                <div class="col-md-12 mb-3">
                    <label>{{ "Address Title" | transloco }}</label>
                    <input type="text" class="form-control" formControlName="address_title"
                        placeholder="{{ 'Home / Work' | transloco }}">
                </div>
                }
                <!-- المحافظة -->
                <div class="col-md-6 mb-3">
                    <label>{{ "Governorate" | transloco }}</label>
                    <select class="form-control" formControlName="government_id" (change)="loadCities($event)"
                        [ngClass]="{
                'is-invalid':
                addressForm.controls['government_id'].touched &&
                addressForm.controls['government_id'].errors,
                'is-valid':
                addressForm.controls['government_id'].touched &&
                !addressForm.controls['government_id'].errors,
                'is-touched':
                addressForm.controls['government_id'].untouched &&
                !addressForm.controls['government_id'].errors,
            }">
                        <option value="">{{ "Select Governorate" | transloco }}</option>
                        <option *ngFor="let gov of governorates" [value]="gov.id">
                            {{ isAr ? gov.governorate_name_ar : gov.governorate_name_en }}
                        </option>
                    </select>
                </div>
                <!-- المدينة -->
                <div class="col-md-6 mb-3">
                    <label>{{ "area" | transloco }}</label>
                    <select class="form-control" formControlName="city_id" [ngClass]="{
                'is-invalid':
                addressForm.controls['city_id'].touched &&
                addressForm.controls['city_id'].errors,
                'is-valid':
                addressForm.controls['city_id'].touched &&
                !addressForm.controls['city_id'].errors,
                'is-touched':
                addressForm.controls['city_id'].untouched &&
                !addressForm.controls['city_id'].errors,
            }">
                        <option value="">{{ "Select area" | transloco }}</option>
                        <option *ngFor="let city of cities" [value]="city.id">
                            {{ isAr ? city.city_name_ar : city.city_name_en }}
                        </option>
                    </select>
                </div>
                <!-- العنوان -->
                <div class="col-md-12 mb-3">
                    <label>{{ "address" | transloco }}</label>
                    <input type="text" class="form-control" formControlName="address" [ngClass]="{
                'is-invalid':
                addressForm.controls['address'].touched &&
                addressForm.controls['address'].errors,
                'is-valid':
                addressForm.controls['address'].touched &&
                !addressForm.controls['address'].errors,
                'is-touched':
                addressForm.controls['address'].untouched &&
                !addressForm.controls['address'].errors,
            }" placeholder="{{ 'Full address' | transloco }}">
                </div>
                <!-- لينك جوجل ماب -->

                <div class="col-md-12 mb-3">
                    <label>{{ "Google Maps Link" | transloco }}</label>
                    <input type="text" class="form-control" formControlName="location_link"
                        placeholder="{{ 'Send Current Locationholder' | transloco }}">
                </div>
                @if(!isCreateOrder){
                <div class="col-md-12 mb-3">

                    <!-- الخريطة -->
                    <google-map height="400px" width="100%" [center]="center" [zoom]="12" [options]="mapOptions"
                        (mapClick)="onMapClick($event)">
                        <map-marker *ngIf="markerPosition" [position]="markerPosition" [options]="markerOptions"
                            (mapDragend)="onMarkerDragEnd($event)">
                        </map-marker>
                    </google-map>

                </div>
                }

            </div>
            <div class="cart-summary">
                <button class="checkout-btn clear-cart" type="button" (click)="getCurrentLocation()">
                    {{ "Send Current Location" | transloco }}
                </button>
                @if(!isCreateOrder){
                <button class="checkout-btn" type="submit" [disabled]="addressForm.invalid">
                    {{ "Add Address" | transloco }}
                </button>
                }
            </div>
        </form>

    </div>
</div>